import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle, Send } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-background" data-id="element-62">
      <div className="max-w-4xl mx-auto px-6" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-surface p-8 md:p-12 rounded-[2.5rem] border border-border text-center" data-id="element-64">
          <h2 className="text-3xl md:text-4xl font-semibold mb-6" data-id="element-65">
            Потрібна бухгалтерська допомога?
          </h2>
          <p className="text-secondary mb-10 text-lg max-w-2xl mx-auto" data-id="element-66">
            Залиште запит — розберемось у вашій ситуації та знайдемо рішення
          </p>

          <div className="flex flex-col items-center justify-center gap-2 mb-10" data-id="element-67">
            <div className="text-xl font-medium text-primary" data-id="element-68">
              Марія Йосипівна
            </div>
            <a href="tel:+380000000000" className="text-2xl font-semibold text-primary hover:opacity-80 transition-opacity" data-id="element-69">
              +38 000 000 00 00
            </a>
            <p className="text-secondary text-sm mt-2" data-id="element-70">
              вул. Центральна, 1, офіс 101 · Безкоштовне паркування
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-71">
            <a href="tel:+380000000000" className="w-full sm:w-auto px-8 py-4 bg-primary text-background rounded-full font-medium flex items-center justify-center gap-2 hover:opacity-90 transition-opacity shadow-lg" data-id="element-72">
              <Phone size={20} data-id="element-73" />
              Зателефонувати
            </a>
            <a href="https://t.me/username" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 bg-surface text-primary border border-border rounded-full font-medium flex items-center justify-center gap-2 hover:bg-border/50 transition-colors shadow-sm" data-id="element-74">
              <Send size={20} data-id="element-75" />
              Написати в Telegram
            </a>
            <a href="viber://chat?number=%2B380000000000" className="w-full sm:w-auto px-8 py-4 bg-surface text-primary border border-border rounded-full font-medium flex items-center justify-center gap-2 hover:bg-border/50 transition-colors shadow-sm" data-id="element-76">
              <MessageCircle size={20} data-id="element-77" />
              Написати в Viber
            </a>
          </div>

          {/* Google Maps Embed Placeholder */}
          <div className="mt-8 rounded-2xl overflow-hidden border border-border h-64 bg-background flex items-center justify-center" data-id="element-78">
            <p className="text-secondary" data-id="element-79">Google Maps буде тут</p>
          </div>
        </motion.div>
      </div>
    </section>;
}